import React, { useRef, useState, useEffect } from "react";
import {Box, Typography, Grid} from '@mui/material';
import {SCROLLBAR_STYLES} from '../../../styles/scrollBar';
import {useForm, FormProvider} from 'react-hook-form';
import FormSubmitButtons from "../../../pieces/formSubmitButtons";
import {yupResolver} from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { CUSTOM_VIEW_FIELDS } from "../../../constants/formFields/customViewFields";
import {ModalContentWrapper} from '../../../pieces/modals/modalWrapper';
import CustomFormBlock from '../../../pieces/inputs/formBlock';
import {inputTypes} from '../../../pieces/inputs/formInput';
import Spacer from '../../../pieces/spacer';
import {toast} from 'react-toastify'
import base_url from '../../../baseUrls';
import ApiUtils from '../../../utils/apiUtils';
import Utils from "../../../utils/utils";

const ManageCustomViews = (props) => {
  

  const formInputDefaultProps = {
    viewMode: false,
    renderLabel: true,
  };

  const validationSchema = Yup.object().shape({
    [CUSTOM_VIEW_FIELDS.CATEGORY.api_name]: Yup.string().required('Please enter the category.'),
    [CUSTOM_VIEW_FIELDS.VIEW_NAME.api_name]: Yup.string().required('Please enter the name of the view.'),
   });

  const formOptions = {resolver: yupResolver(validationSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
    criteriaMode:'all',
  };

  const mainForm = useForm(formOptions);

  const getCustomViewData = ()=> {
    const initialData = props?.customViewData || {};
    return {...initialData, ...mainForm.getValues()};
  };

  const customViewData = getCustomViewData();

  const getDefaultValue = (field, parent=null)=> {
    if(!field) return;
    if(parent) {
      return customViewData?.[parent]?.[field];
    }
    return customViewData?.[field];
  };

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  useEffect( () => {
    //mainForm.setValues({origView: props.origView});

  }, [props.origView]);
  
  useEffect ( () => {

    //console.log('is category');
    //console.log(props.isCategory);

    if (props.isCategory) {
      const name = `XXXX-${generateUUID()}`; 
      mainForm.setValue(CUSTOM_VIEW_FIELDS.VIEW_NAME.api_name, name);
    }
  }, [props.isCategory]);

  if(Utils.isDevEnv()) {
    window.mainForm = mainForm;
  }

  const onSubmit = async (e) => {

    //const isDeleteView = mainForm.getValues(CUSTOM_VIEW_FIELDS.DELETE_VIEW.api_name);

    const dataToSave = { 
          ...props.customViewData, 
          [CUSTOM_VIEW_FIELDS.CATEGORY.api_name]: mainForm.getValues(CUSTOM_VIEW_FIELDS.CATEGORY.api_name),
          [CUSTOM_VIEW_FIELDS.VIEW_NAME.api_name]: mainForm.getValues(CUSTOM_VIEW_FIELDS.VIEW_NAME.api_name)
    };

    const action = (props.crudAction === "delete") ? "delete" :  (dataToSave.id == 0 ? "create" : "edit")

    try {
      const authToken = await ApiUtils.getAccessToken();
      if(!authToken) {
        toast.success('Auth Error: Custom view could not be saved.');
        return;
      }
      const response = await fetch(
        `${base_url.api}customViews/${action}`,
        {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: authToken,
          },
          body: JSON.stringify(dataToSave),
        }
      );

      if (response.status === 201 || response.status === 200) {
        toast.success('Custom view was successfully saved.');        
        const data = await response.json();

        // console.log('new custom view');
        // console.log(data);

        if (props.crudAction === 'add') {
          props.setNewCustomViewId(data.data.customView.id);
        }
        else {
          props.setNewCustomViewId('');
        }

      } else {
        const data = await response.json();
        toast.success(`Error: ${data.message}.`);
        return;
      }
    } catch (e) {
      toast.success(`Error: ${e}.`);
      return;
    }
    props.closeCustomView();

  };

  const onCancel = () => {
    props.closeCustomView();
  }

  return (
    <ModalContentWrapper handleClose={onCancel} header={"Custom View"} >
      <FormProvider {...mainForm}>
        <form onSubmit={mainForm.handleSubmit(onSubmit)} method={'POST'}>
          <CustomFormBlock
              {...formInputDefaultProps}
              field={CUSTOM_VIEW_FIELDS.CATEGORY}
              fullWidth
              defaultValue={getDefaultValue(CUSTOM_VIEW_FIELDS.CATEGORY.api_name)}
              isEditable={true}
          />
          {!props.isCategory && 
           <CustomFormBlock
              {...formInputDefaultProps}
              field={CUSTOM_VIEW_FIELDS.VIEW_NAME}
              fullWidth
              defaultValue={getDefaultValue(CUSTOM_VIEW_FIELDS.VIEW_NAME.api_name)}
              isEditable={true}
          />
          }
          <CustomFormBlock
              {...formInputDefaultProps}
              field={CUSTOM_VIEW_FIELDS.ORIG_VIEW}
              fullWidth
              defaultValue={getDefaultValue(CUSTOM_VIEW_FIELDS.ORIG_VIEW.api_name)}
              isEditable={false}
          />

          {/* <CustomFormBlock
              {...formInputDefaultProps}
              renderLabel={false}
              labelLeft={true}
              inputType={inputTypes.checkbox}
              fullWidth
              field={CUSTOM_VIEW_FIELDS.DELETE_VIEW}
            /> */}

          <Grid>
            <Spacer y={2}/>
            <Box display={'flex'} justifyContent={'center'}>
              <FormSubmitButtons cancelAction={onCancel}
                submitText={ (props.crudAction == 'delete') ? 'Delete' : 'Save'} cancelText='Cancel'
              />
            </Box>
          </Grid>
        </form>
      </FormProvider>
    </ModalContentWrapper>
  );
};

export default ManageCustomViews;
